"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePicker = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const react_1 = __importStar(require("react"));
const im_1 = require("react-icons/im");
const lu_1 = require("react-icons/lu");
const pi_1 = require("react-icons/pi");
const utils_1 = require("../../lib/utils");
const Button_1 = require("../Button/Button");
const Popover_1 = require("../Popover/Popover");
const readOnlyStyles = "read-only:tw-bg-primaryDim-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0 tw-text-neutral-300";
const lockedStyles = "read-only:tw-bg-primary-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0 tw-text-primaryDim-300";
const filePickerInputVariants = (0, class_variance_authority_1.cva)([
    "tw-inline-flex tw-w-full tw-px-3 tw-items-center tw-rounded-md tw-border tw-border-solid tw-border-neutral-100 tw-transition-colors",
    "tw-text-sm tw-text-neutral-200 tw-font-semibold tw-font-sans",
    "focus-visible:tw-ring-ring focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-border-primary-300",
], {
    variants: {
        size: {
            sm: "tw-h-7",
            md: "tw-h-8",
            lg: "tw-h-9",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
const Loading = ({ percentage }) => (react_1.default.createElement("div", { className: "tw-flex tw-h-full tw-items-center tw-justify-center" },
    react_1.default.createElement("span", { className: "tw-w-6" }, percentage),
    react_1.default.createElement(pi_1.PiSpinnerBold, { className: "tw-h-6 tw-w-6 tw-animate-spin tw-text-primary-300" })));
const Dropzone = ({ onSelect }) => {
    const inputFileRef = (0, react_1.useRef)(null);
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const handleFileChange = (event) => {
        if (!event.target.files?.length) {
            return;
        }
        onSelect(event.target.files?.[0]);
    };
    const handleFileDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        if (!event.dataTransfer.files) {
            return;
        }
        onSelect(event.dataTransfer.files?.[0]);
    };
    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };
    const onClickSelect = () => {
        inputFileRef.current?.click();
    };
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)("tw-box-border tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-transition-colors", {
            "tw-rounded-md tw-border-solid tw-border-secondary-300 tw-bg-secondary-50 tw-text-neutral-500": dragging,
        }), onDrop: handleFileDrop, onDragOver: handleDragOver, onDragExit: () => setDragging(false) },
        react_1.default.createElement(lu_1.LuFilePlus2, { className: "tw-h-6 tw-w-6" }),
        react_1.default.createElement("div", { className: "tw-text-center tw-text-xs" },
            dragging ? react_1.default.createElement("p", null, "Drop file here") : react_1.default.createElement("p", null, "Drag & drop into this box"),
            !dragging && react_1.default.createElement("p", { className: "tw-mt-1" }, "- or -")),
        !dragging && react_1.default.createElement(Button_1.Button, { onClick: onClickSelect }, "Select File"),
        react_1.default.createElement("input", { hidden: true, type: "file", ref: inputFileRef, onChange: handleFileChange })));
};
const FilePicker = (0, react_1.forwardRef)(({ size, locked, readOnly, placeholder = "- Add Attachment -", fileName, onSelectFile = () => { }, isLoading, className, percentage = 0, }, ref) => {
    const disabled = locked || readOnly;
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleFileSelected = (file) => {
        onSelectFile(file);
    };
    return (react_1.default.createElement(Popover_1.Popover, { open: open, onOpenChange: setOpen },
        react_1.default.createElement(Popover_1.PopoverTrigger, { disabled: disabled, className: (0, utils_1.cn)({
                [lockedStyles]: locked,
                [readOnlyStyles]: readOnly,
                "tw-cursor-default": disabled,
            }, className), ref: ref, asChild: true },
            react_1.default.createElement("button", { "aria-expanded": open, className: (0, utils_1.cn)(filePickerInputVariants({ size }), {
                    "tw-border-neutral-100": !open,
                    "tw-border-primary-300": open,
                    "tw-text-secondary-200": fileName && !disabled,
                }) },
                react_1.default.createElement("div", { className: "tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap" }, fileName || placeholder),
                react_1.default.createElement(im_1.ImAttachment, { className: (0, utils_1.cn)("tw-ml-auto tw-h-4 tw-w-4 tw-shrink-0 tw-text-neutral-500 tw-transition-transform", { "tw-text-neutral-200": disabled }) }))),
        react_1.default.createElement(Popover_1.PopoverContent, { className: "tw-h-52 tw-w-80 tw-p-2", align: "start" },
            react_1.default.createElement("div", { className: "tw-h-full tw-rounded-md tw-bg-neutral-50 tw-text-neutral-300" }, isLoading ? (react_1.default.createElement(Loading, { percentage: percentage })) : (react_1.default.createElement(Dropzone, { onSelect: handleFileSelected }))))));
});
exports.FilePicker = FilePicker;
FilePicker.displayName = "FilePicker";
